import { createStore, applyMiddleware, compose } from 'redux'
import reduxReset from 'redux-reset'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'
import _ from 'lodash'
import apiMiddleware from '@app/api/middleware'
import pageViewMiddleware from '@app/api/pageViewMiddleware'
import { ActionTypes } from '../constants'
import rootReducer from '../reducers'
import Olympiad from '../models/olympiad'
import Card from '../models/card'
import Event from '../models/event'

const loggerMiddleware = createLogger()

const wrapOlympiads = (olympiads) => {
  return _.map(olympiads, (attributes) => new Olympiad(attributes))
}

const wrapCards = (cards) => {
  return _.map(cards, (attributes) => new Card(attributes))
}

export const history = createBrowserHistory()

history.listen((location, action) => {
  if (action !== 'POP') {
    try { window.scrollTo({ top: 0, behavior: 'auto' }) }
    catch (e) { window.scrollTo(0, 0); }
  }
})

export default function configureStore(preloadedState) {
  return createStore(
    rootReducer(history),

    Object.assign({}, preloadedState, {
      global: {
        ...preloadedState.global,
        event: new Event(preloadedState.global.event),
        olympiads: wrapOlympiads(preloadedState.global.olympiads),
        examples: wrapCards(preloadedState.global.examples)
      }
    }),

    compose(
      applyMiddleware(
        thunkMiddleware,
        loggerMiddleware,
        routerMiddleware(history),
        apiMiddleware,
        pageViewMiddleware
      ),
      reduxReset({
        type: ActionTypes.LOGOUT_SUCCESS,
        data: 'state'
      })
    )
  )
}
